import * as service from './service'
export default {
  namespace: 'recruitJoinWechat',
  state: {
    wechatinfo: {}
  },
  effects: {
    * wechatinfo ({ payload }, { call, put }) {
      try {
        const res = yield call(service.wechatinfo, payload)
        const { data, status } = res.data
        if (status === 200) {
          yield put({
            type: 'save',
            payload: {
              wechatinfo: data
            }
          })
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
